/* Assets/faqrich.js */
(function FAQ(SectionsDesign) {
  'use strict';
function resolveScope(context){
  // Pas de contexte → document
  if (!context) return document;

  // Si on reçoit directement un Element
  if (context.nodeType === 1) return context;

  // Si c'est un event Shopify (shopify:section:load / reorder)
  if (context.target && context.target.nodeType === 1) return context.target;
  if (context.detail && context.detail.sectionId){
    var elFromDetail = document.getElementById('shopify-section-' + context.detail.sectionId)
                   || document.getElementById(context.detail.sectionId);
    return elFromDetail || document;
  }

  // Si c'est une string (ex: section.init(sectionId))
  if (typeof context === 'string'){
    var elFromString = document.getElementById(context)
                    || document.getElementById('shopify-section-' + context);
    return elFromString || document;
  }

  // Fallback
  return document;
}
  if (SectionsDesign.faq) return;          // évite redéclaration globale
  SectionsDesign.faq = {};

  var support = { WebAnimations: typeof Element.prototype.animate === 'function' };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { init(e.target); });

  function init(context) {
    var scope = resolveScope(context);
    var configNodes = Array.from(scope.querySelectorAll('[data-faq-config]'));
    configNodes.forEach(function (configNode) {
      var cfg;
      try { cfg = JSON.parse(configNode.textContent || configNode.innerHTML); } catch (e) { return; }
      if (!cfg || !cfg.sectionId) return;

      var sectionRoot =
        document.getElementById('shopify-section-' + cfg.sectionId) ||
        configNode.closest('[id^="shopify-section-"]') ||
        document;

      var section = compose(publicAPI, setEvents, getBlocks(sectionRoot), getConfig)(cfg);
      SectionsDesign.faq[section.id] = section;
    });
  }

  function publicAPI(config) {
    return {
      id: config.sectionId,
      config: config,
      blocks: zipObj(config.blockIds, config.blocks),
      init: init
    };
  }

  function blockEvents(block) {
    if (!block || !block.trigger || !block.button || !block.panel) return block;
    if (block.trigger.hasAttribute('data-faq-init')) return block;

    block.trigger.setAttribute('data-faq-init', 'true');
    block.trigger.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('a')) return; // évite nav
      toggle(block);
    }, { passive: true });

    return block;
  }

  function toggle(block) { block.collapsed ? expand(block) : collapse(block); return block; }

  function expand(block) {
    if (!block || !block.panel || !block.button) return block;
    block.panel.removeAttribute('hidden'); // visible pour mesurer
    var height = block.panel.scrollHeight;
    block.button.setAttribute('aria-expanded', 'true');

    if (support.WebAnimations) {
      block.panel.setAttribute('data-is-animating', 'true');
      var anim = block.panel.animate(
        [{ height: '0px' }, { height: height + 'px' }],
        { duration: 240, fill: 'both', easing: 'cubic-bezier(0.4,0,0.2,1)' }
      );
      anim.onfinish = function () {
        block.panel.removeAttribute('data-is-animating');
        block.panel.style.height = '';
        this.cancel();
      };
    }
    return block;
  }

  function collapse(block) {
    if (!block || !block.panel || !block.button) return block;
    var height = block.panel.scrollHeight;
    block.button.setAttribute('aria-expanded', 'false');

    if (support.WebAnimations) {
      block.panel.setAttribute('data-is-animating', 'true');
      var anim = block.panel.animate(
        [{ height: height + 'px' }, { height: '0px' }],
        { duration: 240, fill: 'both', easing: 'cubic-bezier(0.4,0,0.2,1)' }
      );
      anim.onfinish = function () {
        block.panel.setAttribute('hidden', '');
        block.panel.removeAttribute('data-is-animating');
        block.panel.style.height = '';
        this.cancel();
      };
    } else {
      block.panel.setAttribute('hidden', '');
    }
    return block;
  }

  function isCollapsed(block) {
    return block && block.button && block.button.getAttribute('aria-expanded') === 'false';
  }

  // Fabrique de blocks SCOPÉE à la section
  function getBlocks(sectionRoot) {
    return function (config) {
      function makeBlock(blockId) {
        if (!blockId) return null;
        var trigger = sectionRoot.querySelector('[data-faq-trigger="' + blockId + '"]');
        var button  = sectionRoot.querySelector('[data-faq-button="' + blockId + '"]');
        var panel   = sectionRoot.querySelector('[data-faq-panel="' + blockId + '"]');
        if (!trigger || !button || !panel) return null;

        return {
          trigger: trigger,
          button: button,
          panel: panel,
          get collapsed() { return isCollapsed(this); },
          select: function () { return expand(this); },
          deselect: function () { return collapse(this); }
        };
      }
      config.blocks = (config.blockIds || []).map(makeBlock).filter(Boolean); // filtre nulls
      return config;
    };
  }

  function setEvents(config) { (config.blocks || []).forEach(blockEvents); return config; }
  function getConfig(cfg) { return cfg; }

  function zipObj(keys, values) {
    return (keys || []).reduce(function (acc, key, idx) { acc[key] = values[idx]; return acc; }, {});
  }

  function compose() {
    var funcs = Array.prototype.slice.call(arguments).reverse();
    return function () {
      return funcs.slice(1).reduce(function (res, fn) { return fn(res); },
        funcs[0].apply(undefined, arguments));
    };
  }
})(window.SectionsDesign = window.SectionsDesign || {});
